import {inject} from 'aurelia-framework';  
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class CaseStudyAPI {


    constructor(http){
        this.http = http;
    }
    
    save(data, ctaFile, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));
        if (ctaFile != null)
            formData.append('cta', ctaFile);

        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/caseStudy/save', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        this.http.get('api/caseStudy/getById/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getList(page, limit, sortBy, sortDir, myVideo, search, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;
        queryString += "&sortBy=" + sortBy;
        queryString += "&sortDir=" + sortDir;
        queryString += "&myVideo=" + myVideo;
        queryString += "&search=" + search;

        this.http.get('api/caseStudy/getList' + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("videos"))
                        successCallback(json.videos);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    sendRequest(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            
            x.withHeader("Authorization", token);
        });

        this.http.post('api/caseStudy/sendRequest', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

   
    acceptVideo(data, ctaFile, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            
            x.withHeader("Authorization", token);
        });

        this.http.post('api/caseStudy/acceptVideo', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    deleteVideo(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            
            x.withHeader("Authorization", token);
        });

        this.http.post('api/caseStudy/deleteVideo', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    remindme(data, successCallback, errorCallback) {

       
        this.http.post('api/caseStudy/remindme', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    if(data.response) {
                        var json = JSON.parse(data.response);

                        if(json.hasOwnProperty("error"))
                            errorCallback(json.error);     
                    }
                    else
                        successCallback();      
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    decline(data, successCallback, errorCallback) {

       
        this.http.post('api/caseStudy/decline', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {

                    if(data.response) {
                        var json = JSON.parse(data.response);

                        if(json.hasOwnProperty("error"))
                            errorCallback(json.error);     
                    }
                    else
                        successCallback();      
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    setPublic(id, value, token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            
            x.withHeader("Authorization", token);
        });

        this.http.post('api/caseStudy/setPublic', {id: id, value: value})
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("public"))
                        successCallback(json.public);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });
    }

    setFeatured(id, value, token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            
            x.withHeader("Authorization", token);
        });

        this.http.post('api/caseStudy/setFeatured', {id: id, value: value})
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("featured"))
                        successCallback(json.featured);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });
    }
    
    saveCaptureOverride(id, num, file, token, successCallback, errorCallback) {

        var formData = new FormData();
        if (file != null)
          formData.append('capture_override', file);
    
        var http = new HttpClient().configure(x => {
          x.withHeader("Authorization", token);
        });
    
        http.post('api/wladmin/caseStudy/saveCaptureOverride/' + id + '/' + num, formData)
          .then(data => {
    
            if (data.isSuccess) {
              successCallback();
            }
            else {
              errorCallback(data.statusText);
            }
          }).catch(error => {
            errorCallback(error.statusText);
        });
    
    }

    removeCaptureOverride(id, num, token, successCallback, errorCallback) {

        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/wladmin/caseStudy/removeCaptureOverride/' + id + '/' + num)
            .then(data => {

            if (data.isSuccess) {
                successCallback();
            }
            else {
                errorCallback(data.statusText);
            }
            }).catch(error => {
                errorCallback(error.statusText);
            });

    }
}